import { config } from 'src/config/config';
import { Http } from 'src/shared/services/Http';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { Country } from '../models/country';

export class CountryService {
    constructor(private http: Http, private toastNotificationsService: ToastNotificationsService) {}

    public async fetchCountries(): Promise<Country[] | void> {
        try {
            return await this.http.makeUnAuthenticatedRequest<Country[]>(
                'GET',
                `${config.apiAddress}countries`,
                null,
                false,
            );
        } catch {
            this.toastNotificationsService.renderErrorToast("Couldn't fetch a list of countries");
        }
    }
}
